/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Sidebar_Delete_Chat_DescInputs */

const es_sidebar_delete_chat_desc = /** @type {(inputs: Sidebar_Delete_Chat_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de eliminar el chat "${i?.title}"? Esta acción no se puede deshacer.`)
};

const en_sidebar_delete_chat_desc = /** @type {(inputs: Sidebar_Delete_Chat_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the chat "${i?.title}"? This action cannot be undone.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete the chat \"{title}\"? This action cannot be undone." |
*
* @param {Sidebar_Delete_Chat_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_chat_desc = /** @type {((inputs: Sidebar_Delete_Chat_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_Chat_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_chat_desc(inputs)
	return en_sidebar_delete_chat_desc(inputs)
});
export { sidebar_delete_chat_desc as "sidebar.delete_chat_desc" }